import React, { FC } from 'react';
import { FiltersProvider } from '../search-snippets/aside/filter-box/FiltersProvider';
import {
  FilterType,
  FilterItem,
} from '../search-snippets/aside/filter-box/FilterItem';
import styles from './mobile_filters.module.scss';

export const MobileFilters: FC = () => (
  <div className={styles.display}>
    <FiltersProvider>
      {(filters: Array<FilterType>) =>
        filters.length > 0 && (
          <div className={styles.container}>
            {filters.map(filter => (
              <FilterItem key={filter.label || filter.title} filter={filter} />
            ))}
          </div>
        )
      }
    </FiltersProvider>
  </div>
);
